var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SwipeContainer", {
    attrs: {
      title: "Swipe left to reject an outfit",
      subtext: "We will filter out items and outfits that you dislike",
      type: "reject"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58dee5ab", { render: render, staticRenderFns: staticRenderFns })
  }
}